const rankingItems = [
  { rank: 1, title: '霸道总裁的契约新娘', type: '韩漫·恋爱', hot: '🔥 12.6万', tag: '韩漫', tagColor: 'bg-accent-100 text-accent-700' },
  { rank: 2, title: '我独自升级', type: '韩漫·奇幻', hot: '🔥 10.8万', tag: '韩漫', tagColor: 'bg-accent-100 text-accent-700' },
  { rank: 3, title: '咒术回战', type: '日漫·热血', hot: '🔥 9.3万', tag: '日漫', tagColor: 'bg-primary-100 text-primary-700' },
  { rank: 4, title: '斗破苍穹', type: '国漫·玄幻', hot: '🔥 8.7万', tag: '国漫', tagColor: 'bg-secondary-100 text-secondary-700' },
  { rank: 5, title: '某天成为公主', type: '韩漫·穿越', hot: '🔥 8.2万', tag: '韩漫', tagColor: 'bg-accent-100 text-accent-700' },
];

export default function RankingSection() {
  return (
    <section id="ranking" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-start gap-10">
          <div className="lg:w-[350px] shrink-0 w-full text-center lg:text-left">
            <span className="inline-block px-3 py-1 rounded-full text-xs font-medium bg-accent-100 text-accent-700 mb-4 whitespace-nowrap">
              热门榜单
            </span>
            <h2 className="text-2xl md:text-4xl font-bold text-foreground-950 font-heading">
              本周人气排行
            </h2>
            <p className="text-sm text-foreground-600 mt-3 leading-relaxed">
              基于阅读量、收藏数和讨论热度综合计算的实时榜单，
              每周一更新，看看大家都在追什么。
            </p>
            <div className="inline-flex items-center gap-1.5 mt-5 px-4 py-2 rounded-full bg-background-100 border border-background-200 text-xs text-foreground-600">
              <i className="ri-timer-line"></i>
              更新时间：2026年7月28日
            </div>
          </div>

          <div className="flex-1 w-full space-y-3">
            {rankingItems.map((item) => (
              <div
                key={item.rank}
                className="flex items-center gap-4 p-4 rounded-2xl bg-background-100 border border-background-200/60 hover:border-primary-300 transition-all duration-200 cursor-pointer"
              >
                <div className={`w-9 h-9 flex items-center justify-center rounded-xl font-bold text-sm shrink-0 ${
                  item.rank <= 3
                    ? 'bg-primary-500 text-white'
                    : 'bg-background-200 text-foreground-600'
                }`}>
                  {item.rank}
                </div>
                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-2 flex-wrap">
                    <h3 className="text-sm font-bold text-foreground-900 truncate font-heading">
                      {item.title}
                    </h3>
                    <span className={`px-1.5 py-0.5 rounded text-[10px] font-medium whitespace-nowrap ${item.tagColor}`}>
                      {item.tag}
                    </span>
                  </div>
                  <div className="text-xs text-foreground-500 mt-0.5">{item.type}</div>
                </div>
                <div className="text-sm font-semibold text-foreground-700 whitespace-nowrap shrink-0">
                  {item.hot}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}